import { mapActions } from 'vuex'

export const reportsMixin1 = {
  data() {
    return {
      showAgencies: false,
      menu0: false,
      dates0: [],
      showInitialTime0: false,
      time1Date1Menu0: false,
      showFinalTime0: false,
      time2Date1Menu0: false,
      time1Date10: null,
      time2Date10: null,
      onlyDate10: null,
      onlyDate20: null,
      date10: null,
      date20: null,
      showClearForm: false,
      fromDateAllowed: '2020-04-30'
    }
  },
  computed: {
    reportButtonDisabled() {
      let result = true
      if (this.dates0.length === 1 && this.time1Date10 && this.time2Date10) result = false
      return result
    }
  },
  methods: {
    ...mapActions(['agencySelectedAction']),
    initData() {
      this.showInitialTime0 = false
      this.time1Date1Menu0 = false
      this.showFinalTime0 = false
      this.time2Date1Menu0 = false
      this.time1Date10 = null
      this.time2Date10 = null
      this.onlyDate10 = null
      this.onlyDate20 = null
      this.date10 = null
      this.date20 = null
    },
    cancelAngeciesTree() {
      this.showAgencies = false
      // this.initData()
    },
    getCurrentHourLimit() {
      const dateTime1 = this.$moment(`${this.date10} ${this.time1Date10}`)
      let duration = this.$moment.duration({from: dateTime1, to: this.$moment.now()})
      duration = Math.trunc(duration.asHours())
      return duration
    },
    isTodayCheck() {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      const result = this.$moment(this.dates0[0]).isSame(today)
      return result
    },
    allowedDates0(date) {
      // console.log('FROM DATE ALLOWED', this.fromDateAllowed)
      let today = this.$moment.now()
      let datesResult = this.$moment(date).isAfter(this.fromDateAllowed) && this.$moment(date).isBefore(today)
      today = this.$moment(today).format('YYYY-MM-DD')

      if (this.dates0.length === 1) datesResult = date === this.dates0[0]

      return datesResult
    },
    changesDate0() {
      if (this.dates0.length === 0) this.initData()
    },
    acceptDate0() {
      if (this.dates0.length > 0) {
        this.time1Date10 = '00:00'
        this.showInitialTime0 = true
      }
      this.$refs.menu0.save(this.dates0)
      this.menu0 = false
    },
    allowedHours0(value) {
      let result = true
      if (this.isTodayCheck()) {
        const today = this.$moment.now()
        const currentHour = Number(this.$moment(today).format('HH'))
        result = value <= currentHour
      }
      return result
    },
    allowedMinutes0(value) {
      let result = true
      if (this.isTodayCheck()) {
        const today = this.$moment.now()
        const currentHour = Number(this.$moment(today).format('HH'))
        const currentMinute = Number(this.$moment(today).format('mm'))

        const date0Time1 = this.$moment(`${this.dates0[0]} ${this.time1Date10}`)
        const hour1 = Number(this.$moment(date0Time1).format('HH'))

        result = hour1 === currentHour
          ? value <= currentMinute
          : true
      }
      return result
    },
    changeTime10() {
      this.time2Date10 = null
    },
    acceptTime10() {
      this.$refs.time1Date1Menu0.save(this.time1Date10)
      const myDate = `${this.dates0[0]} ${this.time1Date10}`
      this.time2Date10 = this.$moment(myDate).add(1, 'm').format('HH:mm')
      this.showFinalTime0 = true
    },
    allowedHours1(value) {
      const myDate = `${this.dates0[0]} ${this.time1Date10}`
      this.date10 = this.dates0[0]

      if (this.time2Date10) {
        const selectedHour1 = this.time1Date10.split(':')
        const selectedHour2 = this.time2Date10.split(':')
        let myDate2 = null

        if (Number(selectedHour2[0]) < Number(selectedHour1[0]) && this.onlyDate10 !== this.onlyDate20) myDate2 = this.onlyDate20
        else myDate2 = this.dates0[0]

        this.date20 = this.$moment(myDate2).format('YYYY-MM-DD')
      }

      let limitOfHour = this.isTodayCheck()
        ? this.getCurrentHourLimit()
        : this.amountOfHours

      limitOfHour = limitOfHour >= this.amountOfHours ? this.amountOfHours : limitOfHour

      const allowedHoursArray = []
      for (let i = 0; i <= limitOfHour; i++) {
        const h = this.$moment(myDate).add(i, 'hours').format('H')
        allowedHoursArray.push(Number(h))
      }

      this.limitTime0 = this.$moment(myDate).add(limitOfHour, 'hours').format('YYYY-MM-DD HH:mm:ss')
      this.onlyDate10 = this.$moment(myDate).format('YYYY-MM-DD')
      this.onlyDate20 = this.$moment(myDate).add(limitOfHour, 'hours').format('YYYY-MM-DD')
      this.limitHour0 = this.$moment(this.limitTime0).format('H')
      this.limitMinute0 = this.$moment(this.limitTime0).format('mm')

      const isIn = allowedHoursArray.filter(item => item === value)
      if (isIn.length > 0) {
        return true
      } else return false
    },
    allowedMinutes1(value) {
      let result = true
      if (this.time2Date10 !== null) {
        if (this.isTodayCheck()) {
          const today = this.$moment.now()
          const currentHour = Number(this.$moment(today).format('HH'))
          const currentMinute = Number(this.$moment(today).format('mm'))

          const dateTime1 = this.$moment(`${this.date10} ${this.time1Date10}`)
          const currentHourDateTime1 = Number(this.$moment(dateTime1).format('HH'))
          const currentMinuteDateTime1 = Number(this.$moment(dateTime1).format('mm'))

          const dateTime2 = this.$moment(`${this.date10} ${this.time2Date10}`)
          const currentHourDateTime2 = Number(this.$moment(dateTime2).format('HH'))

          const inTheSameHour = currentHour === currentHourDateTime2

          if (currentHourDateTime2 === currentHourDateTime1) {
            const checkCurrentCondition = this.getCurrentHourLimit() < 9 && inTheSameHour

            result = checkCurrentCondition
              ? value > currentMinuteDateTime1 && value <= currentMinute
              : value > currentMinuteDateTime1
          } else if (inTheSameHour) {
            result = value <= currentMinute
          }
        } else {
          const selectedHour = this.time2Date10.split(':')
          if (Number(selectedHour[0]) === Number(this.limitHour0)) {
            if (value <= this.limitMinute0) result = true
            else result = false
          }
        }
      }
      return result
    },
    inputTime20(value) {
      this.$nextTick(() => {
        const time1 = new Date(`${this.date10} ${this.time1Date10}`)
        const time2 = new Date(`${this.date20} ${this.time2Date10}`)
        const diffTime = Math.abs(time2 - time1)
        const compareTime = this.amountOfHours * 3600 * 1000
        if (diffTime > compareTime) {
          this.time2Date10 = `${value.split(':')[0]}:00`
        }
      })
    },
    clearForm() {
      this.showClearForm = false
      this.dates0 = []
      this.initData()
      this.agencySelectedAction(null)
    },
    downloadReport() {
      this.showClearForm = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reportsMixin1.js